import { render, staticRenderFns } from "./BaseButtonDangerSmall.vue?vue&type=template&id=12f9a5f6&"
import script from "./BaseButtonDangerSmall.vue?vue&type=script&lang=js&"
export * from "./BaseButtonDangerSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports